import React from "react";
import styles from "./mentor.module.css";
import { MentorPhotos } from "../../page-club/section-about/mentor-photos";

export const SectionMentorAbout = () => {

  return (
    <>
      <section className={styles.sectionMentorContainer} id="mentor">
        <div className={styles.sectionMentorWrap}>

          <div className={styles.sectionMentorInfo}>
            <article className={styles.infoPanel}>
              <div className={styles.cardScanline} aria-hidden="true" />
              <div className={styles.cardCornerTL} aria-hidden="true" />
              <div className={styles.cardCornerBR} aria-hidden="true" />
              <h2 className={styles.sectionMentorInfoTitle}>Мария Бурлакова</h2>
              <p className={styles.sectionMentorInfoText}>
                Руководитель разработки в бигтехе, внутренний и внешний ментор, веду книжный клуб.
              </p>
            </article>

            <article className={styles.infoPanel}>
              <div className={styles.cardScanline} aria-hidden="true" />
              <div className={styles.cardCornerTL} aria-hidden="true" />
              <div className={styles.cardCornerBR} aria-hidden="true" />
              <h2 className={styles.sectionMentorInfoSubtitle}>Немного об успехах</h2>
              <ul className={styles.sectionMentorSuccessList}>
                <li>Запуск стартапа внутри бигтеха с нуля. Наняла в разработку ребят из поддержки. Дала пространство для свободного развития, сейчас они в инженеры в бигтехе.</li>
                <li>Автоматизация: своими руками и джаваскриптом освободила поддержке время на действительно важные задачи. 42млн/год.</li>
                <li>Машина делегирования. Полгода вела сразу две команды разных отделов. Делегировала всю работу с первой командой (12 чел) на них самих.</li>
                <li>Организую необычные процессы: мои команды сами формируют свой флоу, создают схемы ретро под себя. У меня свои матрицы компетенций и свои шаблоны проектирования.</li>
                <li>Симулятор для обучения: +26млн/год, сокращение ошибок в два раза. Сделали mvp втроём за полгода, аналогов в мире нет.</li>
              </ul>
              <h3 className={styles.sectionMentorSubtitle}>Результаты по Симулятору:</h3>
              <ul className={styles.sectionMentorSuccessList}>
                <li>Победа в номинации <a href="https://cc.guru/cca/2025/winners/649" target="_blank" rel="noopener noreferrer">«Лучшая практика обучения и развития персонала»</a> от CCGuru Awards.</li>
                <li>Результаты Симулятора для <a href="https://cxa-spb.rbc.ru/proposals/172/" target="_blank" rel="noopener noreferrer">премии РБК Customer eXperience</a>.</li>
              </ul>
            </article>

            <article className={styles.infoPanel}>
              <div className={styles.cardScanline} aria-hidden="true" />
              <div className={styles.cardCornerTL} aria-hidden="true" />
              <div className={styles.cardCornerBR} aria-hidden="true" />
              <h2 className={styles.sectionMentorInfoSubtitle}>Чему можно научиться</h2>
              <p className={styles.sectionMentorInfoText}>
                Чтобы делать нормально что угодно, нужно просто уметь делать системно. Это самостоятельная компетенция, ей можно научиться.
              </p>
              <p className={styles.sectionMentorInfoText}>Вы научитесь всё делать нормально.</p>
              <h3 className={styles.sectionMentorSubtitle}>Какие темы помогу разобрать:</h3>
              <ul className={styles.sectionMentorTopicsList}>
                <li>Как сделать нормально себе.</li>
                <li>Как сделать нормально команде.</li>
                <li>Настоящая руководительская зрелость. Нормальная взрослая мотивация, наделение полномочиями, субъектность vs жалость к себе и другим.</li>
                <li>Нормальная Agile-зрелость и настоящее скрамгайдовое понимание скрама без фантиков.</li>
                <li>Нормальная работа с правилами, подходами, концепциями.</li>
                <li>Нормальная командная стратегия и способы её составлять.</li>
                <li>Нормальное принятие решений: что такое «заранее» и что такое «по-настоящему плохое решение».</li>
                <li>Нормальный найм.</li>
              </ul>
              <h3 className={styles.sectionMentorSubtitle}>Более сложные темы:</h3>
              <ul className={styles.sectionMentorTopicsList}>
                <li>Нормальный личностный рост: трансформация любого опыта в реальный результат.</li>
                <li>Нормальная работа с настоящими хотелками: как вытащить и не промахнуться.</li>
                <li>Работа с текстом, символическими системами. Сможем разобрать ваше любимое произведение с точки зрения проблем, которые у вас есть в работе. Полезный скилл для генерации новых знаний, а не использования чужих.</li>
              </ul>
            </article>

            <article className={styles.infoPanel}>
              <div className={styles.cardScanline} aria-hidden="true" />
              <div className={styles.cardCornerTL} aria-hidden="true" />
              <div className={styles.cardCornerBR} aria-hidden="true" />
              <h3 className={styles.sectionMentorSubtitle}>Зачем всё это мне</h3>
              <p className={styles.sectionMentorInfoText}>Для меня обучение других — это наиболее продуктивный способ:</p>
              <ul className={styles.sectionMentorTopicsList}>
                <li>Углублять свои знания. За границами теории, книжек и своего опыта.</li>
                <li>Найти и сформировать для себя новые методы улучшения систем.</li>
                <li>Познакомиться со взглядами других людей.</li>
              </ul>
            </article>

            <article className={styles.infoPanel}>
              <div className={styles.cardScanline} aria-hidden="true" />
              <div className={styles.cardCornerTL} aria-hidden="true" />
              <div className={styles.cardCornerBR} aria-hidden="true" />
              <h3 className={styles.sectionMentorSubtitle}>О себе</h3>
              <p className={styles.sectionMentorInfoText}>
                8 лет в бигтехе. Мои подходы – это переосмысленная смесь Голдратта, Талеба, Маска, Юдковского, плюс пересечение теории драматургии, теории торгового хаоса, нейробиологии и герменевтики (работа с семантикой). Генералистка. Тяну: продакт, пипл (найм+развитие), инженерку (фронт), вправление процессов, оседлание хаоса и нормальный скрам, нормальное <b>всё</b>.
              </p>
            </article>
          </div>

          <div className={styles.photosCard}>
            <div className={styles.cardScanline} aria-hidden="true" />
            <div className={styles.cardCornerTL} aria-hidden="true" />
            <div className={styles.cardCornerBR} aria-hidden="true" />
            <MentorPhotos />
          </div>
        </div>
      </section>
    </>
  );
};
